import { useNotes } from 'app/agriculture/queries/notes/useNotes';
import { useMemo } from 'react';
import { Note } from 'app/agriculture/queries/notes/types/Note';

export function useNotesForEntity(id: string) {
    const notes = useNotes();

    const notesByParentId = useMemo(() => {
        const map = new Map<Note['parentId'], Note[]>();
        for (const note of notes.values()) {
            map.set(note.parentId, [...(map.get(note.parentId) ?? []), note]);
        }
        return map;
    }, [notes]);

    return useMemo(() => notesByParentId.get(id) ?? [], [notesByParentId, id]);
}
